import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_DESPESASGERAIS_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterPorId(despesaItemId) {
        return axiosJwt
            .get(`${api}/despesasgerais/requisitantes/itensdespesas/${despesaItemId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterItemDespesaOpcoes() {
        return axiosJwt
            .get(`${api}/despesasgerais/requisitantes/itensdespesas/opcoes`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirItemDespesa(itemDto) {
        return axiosJwt
            .post(`${api}/despesasgerais/requisitantes/itensdespesas/inserir`, itemDto)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    atualizarItemDespesa(itemDto) {
        return axiosJwt
            .put(`${api}/despesasgerais/requisitantes/itensdespesas/atualizar`, itemDto)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirItemDespesa(despesaItemId) {
        return axiosJwt
            .delete(`${api}/despesasgerais/requisitantes/itensdespesas/${despesaItemId}/excluir`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterItens(idsItensDto) {
        return axiosJwt
            .post(`${api}/despesasgerais/requisitantes/itensdespesas/obteritens`, idsItensDto)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
} 